export default __webpack_public_path__ + "static/media/ProductPageImage12.3c115abf.jpg";